import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.3 28.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m1.2 2.5 11.8 10 11.1-5v12.1L4.9 27.4z",
      style: {"fill":"rgba(255,255,255,.5)","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"2px"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M600 0c330.9 0 600 269.2 600 600s-269.1 600-600 600S0 930.8 0 600 269.2 0 600 0m164.4 364.6L600 529 435.6 364.6c-19.6-19.6-51.4-19.6-71 0s-19.6 51.4 0 71L529 600 364.6 764.4c-19.6 19.6-19.6 51.4 0 71s51.4 19.6 71 0L600 671l164.4 164.4c19.6 19.6 51.4 19.6 71 0s19.6-51.4 0-71L671 600l164.4-164.4c19.6-19.6 19.6-51.4 0-71s-51.4-19.6-71 0M13.1 4.6c2.7 0 4.9 2.2 4.9 4.9s-2.2 4.9-4.9 4.9-4.9-2.2-4.9-4.9 2.2-4.9 4.9-4.9M600 0c330.9 0 600 269.2 600 600s-269.1 600-600 600S0 930.8 0 600 269.2 0 600 0m164.4 364.6L600 529 435.6 364.6c-19.6-19.6-51.4-19.6-71 0s-19.6 51.4 0 71L529 600 364.6 764.4c-19.6 19.6-19.6 51.4 0 71s51.4 19.6 71 0L600 671l164.4 164.4c19.6 19.6 51.4 19.6 71 0s19.6-51.4 0-71L671 600l164.4-164.4c19.6-19.6 19.6-51.4 0-71s-51.4-19.6-71 0",
      style: {"fill":"#ff6c4b","fill-rule":"evenodd"}
    }, null, -1),
    _createElementVNode("path", {
      d: "m14.4 7.6-1.3 1.3-1.3-1.3q-.3-.3-.6 0t0 .6l1.3 1.3-1.3 1.3q-.3.3 0 .6t.6 0l1.3-1.3 1.3 1.3q.3.3.6 0t0-.6l-1.3-1.3L15 8.2q.3-.3 0-.6t-.6 0",
      style: {"fill-rule":"evenodd","fill":"#fff"}
    }, null, -1)
  ]))]))
}
export default { render: render }